var _ = require('lodash');
var commonExtractors = require('swa-app-configuration/common-data-extractors');
var dataExtractors = require('swa-analytics/analytics-data-access');

var appDataExtractors = {};

dataExtractors.setExtractors(_.extend({}, commonExtractors, appDataExtractors));
